import { z } from "zod";

export const OrganizationCloseStageSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    organizationId: z.string().uuid(),
    order: z.number().int(),
    rootCloseStageId: z.string().uuid(),
    parentCloseStageId: z.string().uuid().nullable(),
    createdByUserId: z.number().nullable(),
    createdAt: z.coerce.date(),
    updatedByUserId: z.number().nullable(),
    updatedAt: z.coerce.date(),
});

export type OrganizationCloseStage = z.infer<
    typeof OrganizationCloseStageSchema
>;
